import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import { BookOutlined, PersonOutlined, EventOutlined, Sports } from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
const BottomNavi = () => {
  const { pathname } = useLocation();

  const placeId = localStorage.getItem('place_id');

  if (!placeId) {
    // Если place_id отсутствует, не рендерим компонент навигации
    return null;
  }

  return (
    <BottomNavigation
      value={pathname}
      showLabels
      style={{ position: 'fixed', bottom: 0, width: '100%', whiteSpace: 'nowrap' }}
    >
      <BottomNavigationAction
        label='Бронирование'
        icon={<EventOutlined />}
        component={Link}
        to='/booking'
        value={'/booking'}
      />
      <BottomNavigationAction
        label='Тренировки'
        icon={<Sports />}
        component={Link}
        to='/trainings'
        value={'/trainings'}
      />
      <BottomNavigationAction
        label='Мои Брони'
        icon={<BookOutlined />}
        component={Link}
        to='/books'
        value={'/books'}
      />
      <BottomNavigationAction
        label='Профиль'
        icon={<PersonOutlined />}
        component={Link}
        to='/profile'
        value={'/profile'}
      />
    </BottomNavigation>
  );
};

export default BottomNavi;
